var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdrawIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.811,
    height: 18.5,
    viewBox: "0 0 21.811 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Withdraw",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2959",
    "data-name": "Path 2959",
    d: "M22,28.6H34.5",
    transform: "translate(-22 -23.602)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2960",
    "data-name": "Path 2960",
    d: "M26,36.6h2",
    transform: "translate(-22 -23.602)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2961",
    "data-name": "Path 2961",
    d: "M30.5,36.6h4",
    transform: "translate(-22 -23.602)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2962",
    "data-name": "Path 2962",
    d: "M42,34.132v2.08c0,3.51-.89,4.39-4.44,4.39H26.44c-3.55,0-4.44-.88-4.44-4.39v-8.22c0-3.51.89-4.39,4.44-4.39H34.5",
    transform: "translate(-22 -23.602)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2963",
    "data-name": "Path 2963",
    d: "M40,23.6v6l2-2",
    transform: "translate(-22 -23.602)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2964",
    "data-name": "Path 2964",
    d: "M40,29.6l-2-2",
    transform: "translate(-22 -23.602)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawIc);
export default __webpack_public_path__ + "static/media/withdraw-ic.68d7222fe3f5409f41ae6252e60cfb7f.svg";
export { ForwardRef as ReactComponent };